// Avviso sonoro + badge nel titolo della scheda Admin quando arrivano messaggi non letti.
const BASE_TITLE = "BioEdil Abruzzo · Admin";
let lastCount = null;

const beep = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = "sine";
    osc.frequency.value = 880;
    gain.gain.setValueAtTime(0.0001, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.15, ctx.currentTime + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.35);
    osc.start();
    osc.stop(ctx.currentTime + 0.36);
    setTimeout(() => ctx.close(), 600);
  } catch {
    /* audio non disponibile */
  }
};

export const notifyUnread = (count) => {
  document.title = count > 0 ? `(${count}) Nuovi messaggi · ${BASE_TITLE}` : BASE_TITLE;
  if (lastCount !== null && count > lastCount) beep();
  lastCount = count;
};
